module.exports = __webpack_public_path__ + "static/media/signin2.30a64a60.svg";